__turbopack_context__.v({
  "ratingWrapper": "W8JRYq_ratingWrapper",
  "section": "W8JRYq_section",
  "sectionHeader": "W8JRYq_sectionHeader",
  "sectionIntroduction": "W8JRYq_sectionIntroduction",
  "styledButton": "W8JRYq_styledButton",
});
